import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { wrapPageElement as wrapPageElementOrg } from 'gatsby-plugin-i18n-l10n/src/wrapPageElement';
import useSiteMetadata from '../hooks/use-site-metadata';
import useSitePluginI18n from '../hooks/use-site-pluging-i18n';
import { translate } from './Translation';


function SEO(props) {
    const {
        title, description, pathname, children,
    } = props;
    const {
        title: defaultTitle, description: defaultDescription, image, siteUrl,
    } = useSiteMetadata();
    const intl = useIntl();

    const seo = {
        title: ((title && typeof title === 'object') ? translate(title.id, intl, title.children) : title) || defaultTitle,
        description: ((description && typeof description === 'object') ? translate(description.id, intl, description.children) : description) || defaultDescription,
        image: `${siteUrl}${image}`,
        url: `${siteUrl}${pathname || ''}`,
        type: 'website',
        siteName: 'Certego',
    };

    return (
        <>
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <meta property="og:title" content={seo.title} />
            <meta property="og:url" content={seo.url} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:image" content={seo.image} />
            <meta property="og:type" content={seo.type} />
            <meta property="og:site_name" content={seo.siteName} />
            {children}
        </>
    );
}

SEO.defaultProps = {
    description: undefined,
    children: null,
    pathname: null,
    title: undefined,
};

SEO.propTypes = {
    description: PropTypes.any,
    children: PropTypes.node,
    pathname: PropTypes.string,
    title: PropTypes.any,
};


export default function WrapPageElement(props) {
    // Wrap SEO with translation plugin (this plugin use wrapPageElement, so Head is excluded)
    const {
        title, description, allProps: { pageContext }, ...rest
    } = props;

    const { translations } = pageContext;

    const sitePlugin = useSitePluginI18n();

    const options = sitePlugin.pluginOptions;
    const locale = pageContext.locale ?? options.defaultLocale;
    const currentLocale = options.locales.find((l) => l.locale === locale);
    const prefix = pageContext.prefix ?? currentLocale?.prefix;

    return wrapPageElementOrg(
        {
            element: (
                <SEO
                    title={title}
                    description={description}
                    {...rest}
                />
            ),
            props: { pageContext: { locale, prefix, translations } },
        },
        options,
    );
}

WrapPageElement.defaultProps = {
    title: undefined,
    description: undefined,
    allProps: null,
};

WrapPageElement.propTypes = {
    title: PropTypes.any,
    description: PropTypes.any,
    allProps: PropTypes.object,
};
